























































































































import { Vue, Component } from "vue-property-decorator";
import { AttivitaIstituto } from "../../_models/attivitaIstituto";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";
import { bus } from "../../main";
import * as temp from "../../_store/temp.module"


@Component
export default class AttivitaCreate extends Vue {
  private idTipoAttivita: number;
  private dataInizioAttivita: string;
  private dataFineAttivita: string;
  private nomeAttivita: string;
  private nomeAssicurazione: string;
  private numeroAssicurazione: string;
  private descrizioneTipoAttivita: string;

  private listaTipiAttivita: any;
  private searchTipoAttivita: object | null;
  private isLoadingTipoAttivita: boolean;
  private startMenu: boolean;
  private finishMenu: boolean;

  private nomeAttivitaRules: [boolean | string];
  private tipoAttivitaRules: [boolean | string];
  private dataInizioAttivitaRules: [boolean | string];
  private dataFineAttivitaRules: [boolean | string];
  private nomeAssicurazioneRules: [boolean | string];
  private numeroAssicurazioneRules: [boolean | string];

  constructor() {
    super();
    this.idTipoAttivita = 0;
    this.dataInizioAttivita = new Date().toISOString().substr(0, 10);
    this.dataFineAttivita = new Date().toISOString().substr(0, 10);
    this.nomeAttivita = "";
    this.nomeAssicurazione = "";
    this.numeroAssicurazione = "";
    this.descrizioneTipoAttivita = "";

    this.nomeAttivitaRules = [true];
    this.tipoAttivitaRules = [true];
    this.dataInizioAttivitaRules = [true];
    this.dataFineAttivitaRules = [true];
    this.nomeAssicurazioneRules = [true];
    this.numeroAssicurazioneRules = [true];

    this.listaTipiAttivita = [];
    this.searchTipoAttivita = null;
    this.isLoadingTipoAttivita = false;
    this.startMenu = false;
    this.finishMenu = false;
  }

  validazioneNomeAttivita() {
    var valid: boolean = false;
    if (this.nomeAttivita !== "" || this.nomeAttivita !== null) {
      valid = /^[a-zA-Z0-9ìèéùòà'&.\x20/-]{2,50}$/.test(this.nomeAttivita);
    }
    if (valid) {
      this.nomeAttivitaRules = [true];
    } else if (this.nomeAttivita === "" || this.nomeAttivita === null) {
      this.nomeAttivitaRules = ["Nome Attività necessario"];
    } else {
      this.nomeAttivitaRules = [
        "Nome Attività deve essere compresa tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneTipoAttivita() {}
  validazioneDataInizioAttivita() {
    if (this.dataInizioAttivita !== null && this.dataInizioAttivita !== "") {
      this.dataInizioAttivitaRules = [true];
    } else {
      this.dataInizioAttivitaRules = ["Data inizio attività necessaria"];
    }
  }
  validazioneDataFineAttivita() {
    if (this.dataFineAttivita !== null && this.dataFineAttivita !== "") {
      this.dataFineAttivitaRules = [true];
    } else {
      this.dataFineAttivitaRules = ["Data fine attività necessaria"];
    }
  }
  validazioneNomeAssicurazione() {
    var valid: boolean = false;
    if (this.nomeAssicurazione !== "" || this.nomeAssicurazione !== null) {
      valid = /^[a-zA-Z0-9ìèéùòà'&.\x20/-]{2,50}$/.test(this.nomeAssicurazione);
    }
    if (valid) {
      this.nomeAssicurazioneRules = [true];
    } else if (
      this.nomeAssicurazione === "" ||
      this.nomeAssicurazione === null
    ) {
      this.nomeAssicurazioneRules = ["Nome Assicurazione necessario"];
    } else {
      this.nomeAssicurazioneRules = [
        "Nome Assicurazione deve essere compresa tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneNumeroAssicurazione() {
    var valid: boolean = false;
    if (this.numeroAssicurazione !== "" || this.numeroAssicurazione !== null) {
      valid = /^[a-zA-Z0-9ìèéùòà'&.\x20/-]{2,50}$/.test(
        this.numeroAssicurazione
      );
    }
    if (valid) {
      this.numeroAssicurazioneRules = [true];
    } else if (
      this.numeroAssicurazione === "" ||
      this.numeroAssicurazione === null
    ) {
      this.numeroAssicurazioneRules = ["Numero Assicurazione necessario"];
    } else {
      this.numeroAssicurazioneRules = [
        "Numero Assicurazione deve essere compresa tra i 2 e i 50 caratteri"
      ];
    }
  }

  close() {
    this.idTipoAttivita = 0;
    this.dataInizioAttivita = new Date().toISOString().substr(0, 10);
    this.dataFineAttivita = new Date().toISOString().substr(0, 10);
    this.nomeAttivita = "";
    this.nomeAssicurazione = "";
    this.numeroAssicurazione = "";
    this.descrizioneTipoAttivita = "";

    this.nomeAttivitaRules = [true];
    this.tipoAttivitaRules = [true];
    this.dataInizioAttivitaRules = [true];
    this.dataFineAttivitaRules = [true];
    this.nomeAssicurazioneRules = [true];
    this.numeroAssicurazioneRules = [true];

    this.searchTipoAttivita = null;
    this.isLoadingTipoAttivita = false;
    bus.$emit("closeCreateDialog");
  }

  async executeTest() {
    this.validazioneNomeAttivita();
    this.validazioneDataInizioAttivita();
    this.validazioneDataFineAttivita();
    this.validazioneNomeAssicurazione();
    this.validazioneNumeroAssicurazione();
  }

  save() {
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        var nomeTipoAttivita: string = "";
        var index: number = 0;
        for (let i = 0; i < this.listaTipiAttivita.length; i++) {
          if (
            this.listaTipiAttivita[i].idTipoAttivita === this.idTipoAttivita
          ) {
            index = i;
          }
        }
        nomeTipoAttivita = this.listaTipiAttivita[index]
          .descrizioneTipoAttivita;
        var payload: AttivitaIstituto = {
          idAttivita: 0,
          idTipoAttivita: this.idTipoAttivita,
          dataInizioAttivita: this.dataInizioAttivita,
          dataFineAttivita: this.dataFineAttivita,
          nomeAttivita: this.nomeAttivita,
          nomeAssicurazione: this.nomeAssicurazione,
          numeroAssicurazione: this.numeroAssicurazione,
          descrizioneTipoAttivita: nomeTipoAttivita,
          statoIscrizione: false,
          idIstituto: instituteInfo.id,
          idAnnoScolastico: idAnnoScolastico,
          numeroProtocollazione: "",
          dataProtocollazione: "",
          statoPubblicazione: false
        };

        user
          .dispatchCreateAttivitaIstituto(this["$store"], payload)
          .then(() => {
            bus.$emit("createdAttivita");
            bus.$emit(
              "successfullOperation",
              "Attività creata con successo"
            );
            this.close();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      }
    });
  }

  loadTipiAttivita() {
    data
      .dispatchListaTipiAttivita(this["$store"])
      .then(result => {
        this.listaTipiAttivita = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  created(){
    this.loadTipiAttivita()
  }

}
